<script>

import AdminHeader from "@/components/Admin/header.vue";
import AdminOptionsSidebar from "@/components/Admin/options-sidebar.vue";
import {mapState} from "vuex";
import UploadImage from "@/components/Admin/upload-image.vue";
import axios from "axios";
import {CommonMixin} from "@/mixins/commonMethods";

export default {
    components: {AdminHeader, AdminOptionsSidebar, UploadImage},
    mixins: [CommonMixin],
    data: () => ({
        isEdit: false,
        headerText: "",
        descriptionText: "",
        issuesText: "",
        models: {},
        images: [],
        defaultImages: [],
        isValid: false,
        pageInputs: [],
        actProduct: {},
        colors: [],

        storeKeys: {
            products: 'product',
            orders: 'order',
            pages: 'page',
            users: 'user'
        }
    }),
    computed: {
        currentTab() {
            let fullPath = this.$route.path.split('/')
            return fullPath[fullPath.length - 2]
        },
        ...mapState({
            dataStoreKeys(state) {
                if (state[this.storeKeys[this.currentTab]] !== undefined) {
                    return state[this.storeKeys[this.currentTab]][this.currentTab+"Keys"] // например, state.product.productKeys
                }
            },
        }),
        options() {
            let array = []
            let pageOptions = []
            if (this.dataStoreKeys) {
                for (let key in this.dataStoreKeys) {
                    if (key !== "Название продукта" && key !== "Недостатки" && key !== "Описание" && key !== "Заголовок" && key !== "Текст") array.push(key)
                    else pageOptions.push(this.dataStoreKeys[key])
                }
            }

            this.pageInputs = pageOptions
            return array
        },
        defaultValues() {
            if (!this.$route.params.code) {
                return
            }

            let object = {}
            if (this.dataStoreKeys) {
                for (let key in this.dataStoreKeys) {
                    if (key !== "Название продукта" && key !== "Недостатки" && key !== "Описание" && key !== "Заголовок" && key !== "Текст") object[key] = this.actProduct[key]
                }
            }

            return object
        },
        isAllowSave() {
            if (this.headerText && this.descriptionText) return true
            return false
        },
        setLocalImages() {
            return [...this.images];
        },
    },
    methods: {
        setItem(models) {


            if (this.currentTab === 'products') {
                models.productName = this.headerText
                models.descriptionText = this.descriptionText
                models.issuesText = this.issuesText
            } else if (this.currentTab === 'orders') {

            } else if (this.currentTab === 'users') {

            } else if (this.currentTab === 'pages') {
                models.headerText = this.headerText
                models.descriptionText = this.descriptionText
            }

            if (this.images) models.images = this.images

            this.models = models

            if (this.$route.params.code) {
                models.productCode = this.$route.params.code
                this.editRequest(models)
                return
            }

            this.addRequest(models)
        },
        addImages(images) {
            this.images = images
        },
        async addPage(models) {
            const baseUrl = process.env.VUE_APP_API_URL + "";
            const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };
            const res = await axios.post(baseUrl + "/pages/addPage", models, config);
            let pageUrl;
            if (res.data) pageUrl = res.data.pageId
        },
        async addRequest(models) {
            const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };
            const baseUrl = process.env.VUE_APP_API_URL + "";

            switch (this.currentTab) {
                case "products":
                    let { colors, images, ...data } = models;
                    data.seasonStart = parseInt(data.season.split('/')[0])
                    data.seasonEnd = parseInt(data.season.split('/')[1])
                    let { season, ...requestData } = data;
                    // requestData.statusName = 'Active'

                    const res = await axios.post(baseUrl + "/products/addProduct", requestData, config);

                    let productCode;
                    if (res.data) {
                        productCode = res.data.productCode;
                    }

                    if (productCode && this.models.colors) {
                        for (let color of colors) {
                            const res = await axios.post(baseUrl + "/products/addProductColor", {productCode: productCode, colorName: color['Цвет']}, config);
                        }
                    }

                    if (productCode && this.models.images) {
                        // Добавляем картинки

                        let data = {}

                        for (let image of this.models.images) {
                            data.ext = image.src.split(',')[0]
                            data.imageBase64 = image.src.split(',')[1]
                            data.productCode = productCode
                            data.index = image.index
                            data.typeName = image.typeName

                            await axios.post(baseUrl + "/images/addImage", data, config);
                        }
                    }

                    break;

                case 'orders':
                    break;
                case 'pages':
                    await this.addPage(models)

                default:
                    break;
            }
        },
        async editRequest(models) {
            const baseUrl = process.env.VUE_APP_API_URL + "";
            const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };

            switch (this.currentTab) {
                case "products":
                    let { colors, images, ...data } = models;
                    data.seasonStart = parseInt(data.season.split('/')[0])
                    data.seasonEnd = parseInt(data.season.split('/')[1])
                    let { season, ...requestData } = data;

                    await axios.post(baseUrl + "/products/updateProduct", requestData, config);

                    // if (this.colors === colors) {
                    //     break;
                    // }

                    const oldColors = this.colors.map(obj => obj["Цвет"]); // Получаем имена старых цветов
                    const newColors = colors.map(obj => obj["Цвет"]); // Получаем имена новых цветов

                    // Фильтрация цветов, отсутствующих в новом списке; то, что убираем
                    let diffFromOldToNew = oldColors.filter(color => !newColors.includes(color));
                    for (let clr of diffFromOldToNew) {
                        await axios.post(baseUrl + "/products/deleteProductColor", {productCode: this.$route.params.code, colorName: clr }, config);
                    }

                    // Фильтрация новых цветов, отсутствующих в старом списке; то, что добавляем
                    let diffFromNewToOld = newColors.filter(color => !oldColors.includes(color));
                    for (let clr of diffFromNewToOld) {
                        await axios.post(baseUrl + "/products/addProductColor", {productCode: this.$route.params.code, colorName: clr }, config);
                    }

                    let oldImages = this.defaultImages;
                    for (let img of oldImages) {
                        img.src = this.setImageThumbURL(img)
                    }

                    oldImages = oldImages.map(image => image.src);

                    const newImages = this.models.images.map(image => image.src);

                    let diffImgFromOldToNew = oldImages.filter(img => !newImages.includes(img));
                    let diffImgFromNewToOld = newImages.filter(img => !oldImages.includes(img));

                    for (let img of diffImgFromOldToNew) {
                        for (let i of this.defaultImages) {
                            if (this.setImageThumbURL(i) === img) {
                                await axios.post(baseUrl + "/images/deleteImage", {imageUrl: i["Ссылка"]}, config);
                            }
                        }
                    }

                    for (let [ind, img] of diffImgFromNewToOld.entries()) {
                        for (let i of this.models.images) {
                            let data = {}
                            if (i.src === img) {
                                data.ext = i.src.split(',')[0]
                                data.imageBase64 = i.src.split(',')[1]
                                data.productCode = this.$route.params.code;
                                data.index = i.index
                                data.typeName = i.typeName

                                const res = await axios.post(baseUrl + "/images/addImage", data, config);
                            }
                        }
                    }

                    break;
            }

            window.location.reload();
        }
    },
    async beforeMount() {
        if (this.$route.params.code) {
            this.isEdit = true;
            this.localImages = this.setLocalImages

            this.fetchParams = {code: this.$route.params.code}
            await this.$store.dispatch(`product/fetchActualProduct`, this.fetchParams);

            this.actProduct = this.$store.state.product.actualProduct[0]

            this.headerText = this.actProduct['Название продукта']
            this.descriptionText = this.actProduct['Описание']
            this.issuesText = this.actProduct['Недостатки']

            this.fetchParams = {productCode: this.$route.params.code}
            await this.$store.dispatch(`fetchProductColors`, this.fetchParams);
            await this.$store.dispatch(`fetchImages`, this.fetchParams);

            this.colors = this.$store.state.productColors
            this.defaultImages = this.$store.state.images

            if (this.images.length === 0) {
                this.images = this.defaultImages;
            }

            this.actProduct["Цвет"] = this.$store.state.productColors
        }

        if (this.$route.params.number) {
            this.isEdit = true;
        }

        this.$store.dispatch(`user/fetchUsers`);
        this.$store.dispatch(`product/fetchProductsAdmin`);
        this.$store.dispatch(`order/fetchOrders`);
        this.$store.dispatch(`page/fetchPages`);
        this.$store.dispatch(`fetchBrands`);
        this.$store.dispatch(`fetchSizes`);
        this.$store.dispatch(`fetchProductTypes`);
        this.$store.dispatch(`fetchStatuses`);
        this.$store.dispatch(`fetchPageTypes`);
        this.$store.dispatch(`fetchConditions`);
        this.$store.dispatch(`fetchColors`);
    }
}
</script>

<template>
    <admin-header></admin-header>
    <div class="page not-padding">
        <div class="admin-page admin-container-padding">
            <div class="text-elems" v-if="this.currentTab === 'products'">
                <div class="header-text">
                    <div class="input-elem">
                        <input type="text" v-model="headerText" placeholder="Заголовок">
                    </div>
                </div>
                <div class="description-text">
                    <h4>Описание товара</h4>
                    <textarea v-model="descriptionText" placeholder="Введите текст"></textarea>
                </div>
                <div class="issues-text">
                    <h4>Состояние</h4>
                    <textarea v-model="issuesText" placeholder="Введите текст"></textarea>
                </div>
                <upload-image :defaultImages=defaultImages :images=images @update:images="addImages" :is-only-single="false"></upload-image>
            </div>
            <div class="text-elems" v-if="this.currentTab === 'pages'">
                <div class="header-text">
                    <div class="input-elem">
                        <input type="text" v-model="headerText" placeholder="Заголовок">
                    </div>
                </div>
                <div class="description-text">
                    <h4>Текст страницы</h4>
                    <textarea v-model="descriptionText" placeholder="Введите текст"></textarea>
                </div>
                <upload-image :defaultImages=defaultImages :images=images @update:images="addImages" :is-only-single="false"></upload-image>
            </div>
        </div>
        <admin-options-sidebar
            v-if="dataStoreKeys"
            @update:options="setItem"
            class="admin-container-padding"
            :current-tab=currentTab
            :options=options
            :keys=dataStoreKeys
            :isAllowSave=isAllowSave
            :pageInputs=pageInputs
            :defaultValues=defaultValues
            :isEdit="isEdit"
        >
        </admin-options-sidebar>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
    .text-elems {
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
    }

    .text-elems .header-text,
    .text-elems .description-text,
    .text-elems .issues-text {
        width: 100%;
    }

    h4 {
        font-size: 22px;
        font-weight: 500;
        color: $black;
        margin-bottom: 15px;
    }
</style>
